import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import "./CookieConsentBanner.css";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = Cookies.get("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookieConsent", "accepted", { expires: 365 });
    setVisible(false);
  };

  const handleReject = () => {
    Cookies.set("cookieConsent", "rejected", { expires: 365 });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
        <a href="https://shabdtoday.com/PrivacyPolicy" target="_blank" rel="noopener noreferrer"> Learn more</a>.
      </p>
      <div className="cookie-buttons">
        <button onClick={handleAccept} className="accept">Accept</button>
        <button onClick={handleReject} className="reject">Reject</button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;